import { useMemo } from 'react';

import { ImageComponent } from '@/components/Image';
import { useCMSPaymentMethods } from '@/modules/registration';

import { ScRegFormPayments } from './styled';

export const RegFormPayments = () => {
  const { cmsPaymentMethods } = useCMSPaymentMethods();

  const regFormPaymentMethodsLogos = useMemo(() => {
    if (!cmsPaymentMethods) return [];

    return cmsPaymentMethods.methodsGroups
      .flatMap(({ methods }) =>
        methods.filter(({ registrationForm }) => registrationForm)
      )
      .map(({ image }) => ({ src: image.url }));
  }, [cmsPaymentMethods]);

  return regFormPaymentMethodsLogos.length ? (
    <ScRegFormPayments>
      {regFormPaymentMethodsLogos.map(({ src }, i) => (
        <ImageComponent
          src={src}
          key={src + i}
          width={30}
          height={20}
          alt="payment logo"
        />
      ))}
    </ScRegFormPayments>
  ) : null;
};
